import { track } from '../analytics/datalayer'
import { appendFormToken } from './formToken'

/**
 * Email-gate de la plantilla "Política de uso de IA" en /recursos/politica-ia/ (piloto IA).
 * Mismo patrón que leadCotizacion.ts: rellena ts, envía por AJAX a descarga-politica-ia.php,
 * empuja `recurso_descargado` y muestra el éxito inline. La casilla del newsletter va
 * desmarcada (Ley 21.719): sin ella el PHP no da de alta en Brevo, pero la plantilla llega igual.
 */
export function initDescargaPoliticaIa(): void {
  const form = document.getElementById('politica-ia-form') as HTMLFormElement | null
  if (!form) return

  const ts = form.querySelector<HTMLInputElement>('input[name="ts"]')
  if (ts) ts.value = String(Date.now())

  const success = document.getElementById('politica-ia-success')
  const btn = form.querySelector<HTMLButtonElement>('button[type="submit"]')

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    const status = ensureStatus(form)
    status.textContent = ''
    if (btn) btn.disabled = true
    const data = new FormData(form)
    appendFormToken(data)

    try {
      const res = await fetch(form.action, { method: 'POST', body: data })
      const json = (await res.json()) as { ok: boolean; error?: string }
      if (!json.ok) throw new Error(json.error ?? 'error')

      track({ event: 'recurso_descargado', recurso: 'politica-ia', newsletter: data.has('newsletter') })

      if (success) {
        form.hidden = true
        success.hidden = false
        success.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    } catch {
      status.textContent = 'No pudimos enviarla. Reintenta o escríbenos a hola@jalapenos.cl.'
      status.style.color = '#7a1f1f'
      if (btn) btn.disabled = false
    }
  })
}

function ensureStatus(form: HTMLFormElement): HTMLParagraphElement {
  let el = form.querySelector<HTMLParagraphElement>('.form-status')
  if (!el) {
    el = document.createElement('p')
    el.className = 'form-status'
    el.setAttribute('role', 'status')
    form.appendChild(el)
  }
  return el
}
